import { Divider, Form, Input } from 'antd';

export default function PayrollInformation() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <Form.Item name="bank_name" label={'Bank Name'}>
        <Input placeholder="Bank Name" />
      </Form.Item>

      <Form.Item label={'Account Name'} name="account_name">
        <Input placeholder="Account Name" />
      </Form.Item>

      <Form.Item label={'Account Number'} name="account_number">
        <Input placeholder="Account Number" />
      </Form.Item>

      <Form.Item label={'Branch'} name="branch">
        <Input placeholder="Branch" />
      </Form.Item>

      <Form.Item label={'Routing Number'} name="routing_number">
        <Input placeholder="Routing number" />
      </Form.Item>
      <div />
      <Divider className="border-theme-gray-800 md:col-span-2 !mt-4 !mb-0" />
      <Form.Item label={'TIN Number'} name="tin">
        <Input placeholder="TIN Number" />
      </Form.Item>

      <Form.Item
        label="National ID Card Number"
        name="nid"
        rules={[
          {
            validator: (_, value) => {
              if (!value) return Promise.resolve(); // optional field

              // Convert to number safely
              const num = Number(value);
              const strValue = value.toString();

              if (isNaN(num)) {
                return Promise.reject('NID must be a number');
              }

              if (!Number.isInteger(num)) {
                return Promise.reject('NID cannot be decimal');
              }

              if (num < 0) {
                return Promise.reject('NID cannot be negative');
              }

              if (!/^[0-9]+$/.test(value)) {
                return Promise.reject('NID must contain only digits');
              }
              if (strValue.length < 10 || strValue.length > 17) {
                return Promise.reject('NID must be between 10 and 17 digits');
              }
              return Promise.resolve();
            },
          },
        ]}
      >
        <Input placeholder="Enter National ID Card Number" />
      </Form.Item>
    </div>
  );
}
